/**
 * NoAccess page.
 *
 * Displayed for users with no project memberships.
 * Shows a message to contact the administrator for access.
 */
import { Button } from "@frontend/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@frontend/components/ui/card"

export function NoAccess() {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardHeader>
          <CardTitle className="text-center">No Access</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-center text-muted-foreground">You don't have access to any projects.</p>
          <p className="text-center text-sm text-muted-foreground">
            Please contact your administrator to request access. They can send you an invitation to this instance or add
            you to a project.
          </p>
          <div className="flex justify-center">
            <Button variant="outline" onClick={() => window.location.assign("/")}>
              Reload
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
